/**
 * Created by piotr.pozniak@thebeaverhead.com on 18/07/2023
 *
 * ICSDelete jobs carry calendar_name/organization_name (App\Utility\QueueICS
 * on the backend), not plan/email like the integration sync jobs — no
 * account email means Auto login doesn't apply here either.
 */
import React from "react";
import QueueJobsListPage from "./QueueJobsPage/QueueJobsListPage";
import { accountLabelByOrganization, calendarColumn } from "./QueueJobsPage/columns";

const QueuedICSCleanPage = () => (
  <QueueJobsListPage
    title="ICS calendar clean jobs"
    jobType="ICSDelete"
    routeBase="/ics-clean-jobs"
    hasDuration
    accountLabel={accountLabelByOrganization}
    secondaryColumn={calendarColumn}
  />
);

export default QueuedICSCleanPage;
